import { useAuth } from '../../contexts/AuthProvider/useAuth';
import { AppRoutes } from '../../routes';
import { isMobileDevice } from '../../commons/utils';
import { useEffect, useState } from 'react';
import { ExAppBar, ExDrawer, ExIconButtonAuxSideBar, ExMain } from './SideBar/components';
import { Box, Toolbar } from '@mui/material';
import { SideBar } from './SideBar';
import { SwitchTheme } from '../../components/SwitchTheme';
import { useThemeContext } from '../../theme';
import { Dropdown } from 'react-bootstrap';
import { DropdownItem, DropdownToggle, TitleToogle } from '../../components/ExNavbar';
import { Icon } from 'lucide-react';
import { farm } from '@lucide/lab';
import { Input } from '../../components/Input';

export const Principal = () => {
    const auth = useAuth();
    const { themeMode, toggleTheme } = useThemeContext();

    const [expanded, setExpanded] = useState<any>(true);
    const [search, setSearch] = useState<string>('');

    async function alterUser(grupo: string, refresh: boolean) {
        if (auth.usuemail && auth.ususenha) {
            await auth.authenticate(auth.usuemail, auth.ususenha, grupo)
                .then(() => {
                    if (refresh)
                        window.location.reload()
                })
        }
    }

    const clickExpanded = () => setExpanded(!expanded);

    const clickItemMenu = (to: any) => {
        setExpanded(to === undefined ? true : !isMobileDevice());
    };

    useEffect(() => {
        if (auth.grupo)
            alterUser(auth.grupo, false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredGrupos = auth.grupos?.filter((g: any) =>
        g.grudescricao.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Box style={{ display: 'flex' }}>
            <ExAppBar position="fixed" open={expanded}>
                <Toolbar id='principal-toolbar' variant='dense' style={{ backgroundColor: 'var(--side-bar-color)' }} >
                    <ExIconButtonAuxSideBar onClick={clickExpanded} />
                    <SwitchTheme
                        defaultChecked={themeMode === 'dark'}
                        sx={{ position: `${isMobileDevice() ? 'fixed' : 'relative'}`, left: `${isMobileDevice() ? '3rem' : '0'}` }}
                        onChange={toggleTheme}
                    />

                    {(auth.grupos) &&
                        <Dropdown style={{ position: 'fixed', right: 0, marginRight: '20px', minWidth: '230px' }}>
                            <DropdownToggle>
                                <TitleToogle>
                                    <Icon iconNode={farm} height={'20px'} style={{ marginRight: '5px', marginBottom: '3px' }} />
                                    Selecione o grupo:
                                </TitleToogle>
                                {auth.grupo.grudescricao}
                            </DropdownToggle>

                            <Dropdown.Menu style={{ padding: '8px', width: '400px' }}>
                                <Input
                                    id="searchGrupo"
                                    type="text"
                                    placeholder="Pesquisar grupo..."
                                    search
                                    noDebounce
                                    onAfterChange={(value: string) => setSearch(value)}
                                />

                                <div style={{ maxHeight: '400px', overflowY: 'auto', marginTop: '4px' }}>
                                    {filteredGrupos?.length > 0 ? (
                                        filteredGrupos
                                            .sort((a: any, b: any) => a.grudescricao.localeCompare(b.grudescricao))
                                            .map((grupo: any, index: any) => (
                                                <DropdownItem
                                                    key={index}
                                                    onClick={() => alterUser(grupo, true)}
                                                    style={{
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        paddingRight: '8px',
                                                        paddingLeft: '8px',
                                                    }}
                                                    title={grupo.grudescricao}
                                                >
                                                    {grupo.grudescricao}
                                                </DropdownItem>
                                            ))
                                    ) : (
                                        <div style={{ padding: '8px', textAlign: 'center', color: '#888' }}>
                                            Nenhum grupo encontrado
                                        </div>
                                    )}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                </Toolbar>
            </ExAppBar>

            <ExDrawer open={expanded} variant={isMobileDevice() ? "temporary" : "persistent"} >
                <SideBar clickExpanded={clickExpanded} clickItemMenu={clickItemMenu} />
            </ExDrawer>

            <ExMain open={expanded}>
                <div style={{ padding: '2px', marginTop: '48px', backgroundColor: 'var(--background-color)', borderTopLeftRadius: '6px' }}>
                    <AppRoutes />
                </div>
            </ExMain>
        </Box >
    )
}